import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'

import LoadingScreen from '@/components/feedback/LoadingScreen'
import { useAuth } from '@/hooks/useAuth'

interface ProtectedRouteProps {
  children: ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!user) {
    return <Navigate to="/atelier" state={{ from: location.pathname }} replace />
  }

  return <>{children}</>
}
